import React from 'react';
import { useHistory } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';
import Icons from '../../components/Icons/Icons';
import classNames from 'classnames';

import css from './BlogPage.module.css';

const MobileTabMenu = ({ onClickFilter, toggleFilter, renderBlogTags, onViewAll, currentTag }) => (
  <div className={css.mobileTabMenu}>
    <span className={css.mobileTabMenuIcon} onClick={onClickFilter}>
      <Icons name="filter" />
    </span>
    {toggleFilter && (
      <div className={css.mobileTabMenuItems}>
        <span
          className={classNames({
            [css.active]: !currentTag,
          })}
          onClick={onViewAll}
        >
          View All
        </span>
        {renderBlogTags}
      </div>
    )}
  </div>
);

const BlogFilterTabs = ({ renderBlogTags, onViewAll, currentTag }) => (
  <div className={css.blogFilterTabs}>
    <span
      className={classNames({
        [css.active]: !currentTag,
      })}
      onClick={onViewAll}
    >
      View All
    </span>
    {renderBlogTags}
  </div>
);

const BlogTabs = ({ isMobileLayout, onClickFilter, toggleFilter, renderBlogTags, currentTag }) => {
  const history = useHistory();

  const onViewAll = () => {
    history.push(createResourceLocatorString('BlogPage', routeConfiguration(), {}, {}));
  };

  return isMobileLayout ? (
    <MobileTabMenu
      onClickFilter={onClickFilter}
      toggleFilter={toggleFilter}
      renderBlogTags={renderBlogTags}
      currentTag={currentTag}
      onViewAll={onViewAll}
    />
  ) : (
    <BlogFilterTabs renderBlogTags={renderBlogTags} currentTag={currentTag} onViewAll={onViewAll} />
  );
};

export default BlogTabs;
